export default __webpack_public_path__ + "static/mobile-bg-bottom-mask-d2817264dee5facc87ba1adf6c7d175f.png";